import styled from 'styled-components';

enum TextPosition {
  left = 'start',
  center = 'center',
  right = 'end'
}

interface IFlexItemInterface {
  alignText?: TextPosition;
}

const FlexItem = styled.div<IFlexItemInterface>`
  display: flex;
  flex: 1;
  text-align: ${props => TextPosition[props.alignText || TextPosition.left]};
`;

export { FlexItem, TextPosition };



// WEBPACK FOOTER //
// ./src/components/FlexItem/FlexItem.tsx